import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet, doAsyncPost } from '@/api/async-util'

const types = {
    IS_INSTALL_ID_VALID: createAsyncMutation('IS_INSTALL_ID_VALID'),
    POST_LICENSE_ACTIVATION: createAsyncMutation('POST_LICENSE_ACTIVATION'),
    POST_REPLACE_LICENSE_ACTIVATION: createAsyncMutation('POST_REPLACE_LICENSE_ACTIVATION'),
    IS_MAX_ACTIVATIONS_EXCEEDED: createAsyncMutation('IS_MAX_ACTIVATIONS_EXCEEDED'),
    PROCESS_LICENSE_ACTIVATION: createAsyncMutation('PROCESS_LICENSE_ACTIVATION'),
}

const activation = {
    state: {
        continueToActivateLicenseKeyClicked: false,
    },
    mutations: {
        update_continueToActivateLicenseKeyClicked(state, clicked) {
            state.continueToActivateLicenseKeyClicked = clicked
        },
    },
    actions: {
        // GET

        validateInstallId(store, payload) {
            let url = api.activation + 'ValidateInstallID'
            if (payload) {
                url += '?installId=' + payload.installId.trim()
                url += '&productCategoryId=' + payload.productCategoryID
            }
            return doAsyncGet(store, { url, mutationTypes: types.IS_INSTALL_ID_VALID })
        },

        // POST
        generateActivation(store, payload) {
            let url = api.activation + "License/Generate"
            return doAsyncPost(store, { url, mutationTypes: types.POST_LICENSE_ACTIVATION, payload })
        },

        replaceActivation(store, payload) {
            let url = api.activation + "License/Replace"
            return doAsyncPost(store, { url, mutationTypes: types.POST_REPLACE_LICENSE_ACTIVATION, payload })
        },

        isMaxActivationsExceeded(store, payload) {
            let url = api.activation + "License/IsMaxExceeded"
            return doAsyncPost(store, { url, mutationTypes: types.IS_MAX_ACTIVATIONS_EXCEEDED, payload })
        },

        processLicenseKeyActivation(store, payload) {
            let url = api.activation + 'License/GenerateFromLicenseKey'

            if (payload) {
                url += '?customerId=' + payload.customerId
                url += '&licenseKey=' + payload.licenseKey
                url += '&installId=' + payload.installId
                url += '&productId=' + payload.productId
            }

            return doAsyncPost(store, { url, mutationTypes: types.PROCESS_LICENSE_ACTIVATION, payload })
        }

    },
    getters: {
        continueToActivateLicenseKeyClicked: state => state.continueToActivateLicenseKeyClicked,
    },
    types: types
}

export default activation
